module.exports = __webpack_public_path__ + "img/38312.prt.9c000193.jpg";